
// 获取一个节点的所有父节点【id】包含当前节点
const getNodePath = (nodes, current, parentNodes) => {
  for (let i = 0; i < nodes.length; i++) {
    if (nodes[i].childrenNode && nodes[i].childrenNode.length) {
      const end = getNodePath(nodes[i].childrenNode, current, parentNodes);
      if (end) {
        parentNodes.push(nodes[i].id);
        return true;
      }
    }
    if (nodes[i].id === current) {
      parentNodes.push(nodes[i].id);
      return true;
    }
  }
  return false;
};

// 查找指定的节点
const getNode = (nodes, current) => {
  for (let i = 0; i < nodes.length; i++) {
    if (nodes[i].id === current) {
      return nodes[i];
    }
    if (nodes[i].childrenNode && nodes[i].childrenNode.length) {
      const node = getNode(nodes[i].childrenNode, current);
      if (node) {
        return node;
      }
    }
  }
  return null;
};

// 获取所有子节点
const getNodes = (nodes, children) => {
  for (let i = 0; i < nodes.length; i++) {
    children.push(nodes[i].id);
    if (nodes[i].childrenNode && nodes[i].childrenNode.length) {
      getNodes(nodes[i].childrenNode, children);
    }
  }
};

// 获取指定节点的父节点（路径）
export function getParentNodes(permission, current) {
  const parentNodes = [];
  getNodePath(permission, current, parentNodes);
  parentNodes.reverse().pop();
  return parentNodes;
}

// 获取指定节点的子节点
export function getChildNodes(permission, current) {
  const childrenNode = [];
  const currentNode = getNode(permission, current);
  if (!!currentNode && currentNode.childrenNode && currentNode.childrenNode.length) {
    getNodes(currentNode.childrenNode, childrenNode);
  }
  return childrenNode;
}

// 获取指定节点的父节点
export function getParentNode(permission, parentId) {
  const node = getNode(permission, parentId);
  return node;
}

// 获取下一级页面
export function getChildrenNext(permissioNode) {
  const nodes = [];
  if (permissioNode.childrenNode && permissioNode.childrenNode.length) {
    for (let i = 0; i < permissioNode.childrenNode.length; i++) {
      if (permissioNode.resourceType === 1) { // 页面
        nodes.push(permissioNode.childrenNode[i].id);
      }
    }
  }
  return nodes;
}

// 获取对象数组中指定key的值
export function getValuesByKeyFromArrayObject(arr, key) {
  const values = [];
  if (arr.length) {
    for (let i = 0; i < arr.length; i++) {
      values.push(arr[i][key]);
    }
  }
  return values;
}
